import * as React from 'react';
import { connect } from 'react-redux';

import { ModalFrame, ModalFrameFooter, ModalFrameInner } from 'components/modal';
import ActionButton from 'components/buttons/action-button/ActionButton';
import SelectStorySnippetsFilters from '../select-story-snippets-filters/SelectStorySnippetsFilters';
import SelectStorySnippetsEntitiesCount from '../select-story-snippets-entities-count/SelectStorySnippetsEntitiesCount';
import SelectStorySnippetsGrid from '../select-story-snippets-grid/SelectStorySnippetsGrid';
import SelectStorySnippetsSpinner from '../select-story-snippets-spinner/SelectStorySnippetsSpinner';

import { flushStateAction, init, onSaveSnippets } from '../../redux/actions';

import { __t, applyTranslations } from 'utils/language';

import './select-story-snippets-modal.scss';

applyTranslations(require('./select-story-snippets-modal.i18n.json'));

import { OnSelectCallback } from '../../types';

interface DispatchProps {
  dispatchOnMount: () => void,
  dispatchOnUnmount: () => void,
  dispatchOnSave: () => void
}

/* eslint-disable react/no-unused-prop-types */
interface OwnProps {
  campaignStartDate: string,
  deliverableId: number,
  saveButtonText?: string,
  selectedStorySnippets?: Array<string>,
  saveChangesOnClose?: boolean,
  onCloseModal: () => void,
  onSelect: OnSelectCallback
}
/* eslint-enable react/no-unused-prop-types */

type Props = DispatchProps & OwnProps;

const SelectStorySnippetsModal = ({
  saveButtonText,
  onCloseModal,
  dispatchOnMount,
  dispatchOnUnmount,
  dispatchOnSave
}: Props): JSX.Element => {
  React.useEffect(() => {
    dispatchOnMount();

    return dispatchOnUnmount;
  }, []);

  return (
    <div className="select-story-snippet-modal">
      <ModalFrame
        title={__t('select_story_snippets_modal.header')}
        subtitle={__t('select_story_snippets_modal.subheader')}
        classNameFrame="select-story-snippet-modal__frame"
      >
        <ModalFrameInner>
          <div className="select-story-snippet-modal__content">
            <SelectStorySnippetsFilters />
            <SelectStorySnippetsEntitiesCount />
            <SelectStorySnippetsGrid />
            <SelectStorySnippetsSpinner />
          </div>
        </ModalFrameInner>
        <ModalFrameFooter>
          <ActionButton
            color="tertiary"
            onClick={onCloseModal}
          >
            {__t('select_story_snippets_modal.footer.cancel')}
          </ActionButton>
          <ActionButton
            onClick={dispatchOnSave}
          >
            {saveButtonText ?? __t('select_story_snippets_modal.footer.select')}
          </ActionButton>
        </ModalFrameFooter>
      </ModalFrame>
    </div>
  );
};

const mapDispatchToProps = (
  dispatch,
  {
    campaignStartDate,
    deliverableId,
    saveChangesOnClose,
    selectedStorySnippets,
    onSelect,
    onCloseModal
  }: OwnProps
): DispatchProps => ({
  dispatchOnMount: () => dispatch(
    init(deliverableId, campaignStartDate, onSelect, selectedStorySnippets, saveChangesOnClose)
  ),
  dispatchOnUnmount: () => dispatch(flushStateAction()),
  dispatchOnSave: async () => {
    await dispatch(onSaveSnippets(deliverableId));
    onCloseModal();
  }
});

export default connect(null, mapDispatchToProps)(SelectStorySnippetsModal);
